module.exports = __webpack_public_path__ + "static/2-e55e629f12b873d6035e1bee3e93eb01.jpg";